/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PermissionRepresentationFromJSON, PermissionRepresentationToJSON, } from './';
export function RemovePermissionsUserRequestFromJSON(json) {
    return RemovePermissionsUserRequestFromJSONTyped(json, false);
}
export function RemovePermissionsUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        permissions: json['permissions'].map(PermissionRepresentationFromJSON),
    };
}
export function RemovePermissionsUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        permissions: value.permissions.map(PermissionRepresentationToJSON),
    };
}
